import axios from 'axios';

export const get = async (
    url,
    headers = {'Content-Type': 'application/json'},
) => {
    const api = axios.create();

    api.interceptors.request.use(config => {
        return config;
    });

    api.interceptors.response.use(
        response => {
            return response;
        },
        function(error) {
            return Promise.reject(error);
        },
    );

    let response = await api.get(url);

    return response.data;
};
